import { Component, OnInit } from '@angular/core';
import { ActionSheetController, ModalController, NavController } from '@ionic/angular';
import { HistoryViewComponent } from 'src/app/components/history-view/history-view.component';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { StatePublication } from 'src/app/Models/Classes/Publications/Story/StatePublication/state-publication';
import {ModulesLockComponent} from "../../../go-ecosystem/modules-lock/modules-lock.component";
import { InputAlertControllerService } from 'src/app/services/utils/input-alert-controller.service';
import { SliderInformationComponent } from 'src/app/components/slider-information/slider-information.component';
import { PagoVerificacionComponent } from 'src/app/components/pago-verificacion/pago-verificacion.component';
import { WalletServiceService } from 'src/app/services/wallet/wallet-service.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import {Capacitor} from "@capacitor/core";
import { ShootingStar6Component} from 'src/app/components/publication/create/shooting-star/shooting-star6/shooting-star6.component';
import  Swal from 'sweetalert2';
import {InlineBowsingComponent} from 'src/app/inline-bowsing/inline-bowsing.component';
import { CreateProductComponent } from 'src/app/components/go-ecosystem/store/create-product/create-product.component';
import { Router} from '@angular/router';
import { RegistrationIntentService } from 'src/app/services/auth/registration-intent.service';
import { NativeLiquidGlass } from 'src/app/plugins/native-runtime.plugins';
@Component({
  selector: 'app-new-publication-button',
  templateUrl: './new-publication-button.component.html',
  styleUrls: ['./new-publication-button.component.scss'],
})
export class NewPublicationButtonComponent implements OnInit {
  pr:any
  isActionSheetPresented:boolean=false;
  private storyModalOpen = false;
  constructor(private formservice: FormServiceService,
    private modalController: ModalController,
    private ActionSheetController: ActionSheetController,
    public navCtrl: NavController,
    private inputAlertController: InputAlertControllerService,
    private walletService: WalletServiceService,
   
    private profile:ProfileService,
    private router:Router,
    private registrationIntent: RegistrationIntentService,
  ) { }
  //Se llena el array
  ngOnInit() {

    if (this.formservice.profile){
      this.pr=this.formservice.profile;
      this.pr.username=this.formservice.profile?.username;
      this.pr.profile_photo=this.formservice.profile?.profile_photo;
    }else{
      this.profile.getProfileInfo().then((result)=>{
        this.pr = JSON.parse(result);
        console.log("profile", this.pr);
      });
  
    }

  }
ngAfterViewInit(){

}
  private hasActiveProfile(): boolean {
    return !!this.formservice.profile;
  }

  private syncProfileReference() {
    if (!this.hasActiveProfile()) {
      this.pr = undefined;
      return;
    }

    this.pr = this.formservice.profile;
    this.pr.username = this.formservice.profile?.username;
    this.pr.profile_photo = this.formservice.profile?.profile_photo;
  }

  // redirectCreatePublication() {
  // 	//redirect to create publication
  // 	this.navCtrl.navigateForward('create-publication');
  // }
  async presentActionSheet() {
    this.syncProfileReference();

    if (!await this.registrationIntent.requireAccount('create-publication')) {
      return;
    }

    if (this.isActionSheetPresented) {
      return; // Prevent multiple invocations
    }

    const publicationOptionsDisabled = !this.hasActiveProfile();
    const actionButtonClass = publicationOptionsDisabled
      ? 'icon custom-action-sheet action-sheet-option-disabled'
      : 'icon custom-action-sheet';
    const stopWhenLoggedOut = () => {
      if (publicationOptionsDisabled) {
        Swal.fire({
          title: '🔑',
          text: 'You must sign in. Da click en "🔑PERFIL", para ver tu perfil.',
          icon: 'info',
          confirmButtonText: 'Understood',
          background: '#010f4e',
        });
        return false;
      }

      return true;
    };

    this.isActionSheetPresented = true;
    const actionSheet = await this.ActionSheetController.create({
      header: '¿Qué vas a publicar?',
      cssClass: 'title-action custom-action-sheet',
      buttons: [{
        text: 'Historia',
        icon: 'hourglass-outline',
        cssClass: actionButtonClass,
        handler: () => {
          if (!stopWhenLoggedOut()) {
            return false;
          }
          let ecosystem = "story";
          this.presentModalHistory();
        }
      }, {
        text: 'Social',
        icon: 'person-outline',
        cssClass: actionButtonClass,
        handler: () => {
          if (!stopWhenLoggedOut()) {
            return false;
          }
          let ecosystem = "normal";
          this.formservice.publication_type = ecosystem;
          this.presentModal();
        }
      }, 
      /*
      {
        text: 'Bienes FEEX',
        icon: 'cart-sharp',
        cssClass: 'icon custom-action-sheet',
        handler: () => {
          Swal.fire({
            title: '¿Qué deseas hacer?',
            text: 'Selecciona una opción: publicar un producto que tienes en inventario o proceder con dropshipping.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Publicar producto',
            cancelButtonText: 'Dropshipping',
            color: '#ffffff',
            background: '#010f4e',
          }).then((result) => {
            if (result.isConfirmed) {
              // Call your function for posting a product in stock
              this.openKYCApplicationModal('feex');
            } else {
              // Call your function for dropshipping
              this.openKYCApplicationModal('dropship');
            }
          });
          
        

        }
      }, */
      {
          text: 'Servicios Land',
          icon: 'body-outline',
          cssClass: actionButtonClass,
          handler: () => {
            if (!stopWhenLoggedOut()) {
              return false;
            }
            //let ecosystem = "land";
            //this.formservice.publication_type = ecosystem
            //this.presentModal();
            this.openKYCApplicationModal('land');
          }
        }, {
          text: 'Educación Epoch',
          icon: 'easel',
          cssClass: actionButtonClass,
          handler: () => {
            if (!stopWhenLoggedOut()) {
              return false;
            }
           // let ecosystem = "epoch";
           // this.formservice.publication_type = ecosystem
           // this.presentModal();
           this.openKYCApplicationModal('epoch');
          }
        }, {
          text: 'Transmisión en vivo',
          icon: 'radio-sharp',
          cssClass: actionButtonClass,
        handler: () => {
          if (!stopWhenLoggedOut()) {
            return false;
          }
           // let ecosystem = "earth";
           // this.formservice.publication_type = ecosystem
           // this.presentModal();
           this.openKYCApplicationModal('live');
          }
        },
        /*
        {
          text: 'Entrelazamiento ',
          icon: 'git-merge-sharp',
          cssClass: 'icon custom-action-sheet',
          handler: () => {
           let ecosystem = "earth";
           this.formservice.publication_type = 'Entrelazamiento';
           Swal.fire({
            title: 'No disponible',
            text: 'This app is currently unavailable',
            icon: 'warning',
            //showCancelButton: true,
            //cancelButtonText:'Cancel',
            confirmButtonColor: 'green',
            color: '#ffffff',
            background: '#010f4e',
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // Handle logout process here
              //this.logout_button();
            }
          });
          return;
           // this.presentModal();
           this.openEntrelazamiento();
          }
        },
        */

      // {
      //   text: 'Servicios. Land',
      //   icon: 'cog',
      //   cssClass: 'icon',
      //   handler: () => {
      //     let ecosystem = "land";
      //     this.formservice.publication_type = ecosystem
      //     this.presentModal();

      //   }
      // }, {
      //   text: 'Eventos. Eclipse',
      //   icon: 'calendar-number-outline',
      //   cssClass: 'icon',
      //   handler: () => {
      //     let ecosystem = "eventos";
      //     this.formservice.publication_type = ecosystem
      //     this.presentModal();

      //   }
      // }, {
      //   text: 'Educación. Epoch',
      //   icon: 'book-outline',
      //   cssClass: 'icon',
      //   handler: () => {
      //     let ecosystem = "epoch";
      //     this.formservice.publication_type = ecosystem
      //     this.presentModal();

      //   }
      // }, {
      //   text: 'Hospedaje. Earth',
      //   icon: 'bed',
      //   cssClass: 'icon',
      //   handler: () => {
      //     let ecosystem = "earth";
      //     this.formservice.publication_type = ecosystem
      //     this.presentModal();

      //   }
      // }
    ]
    });
    const isIOS = Capacitor.getPlatform() === 'ios';
    try {
      if (isIOS) {
        await NativeLiquidGlass.setChromeSuppressed({ suppressed: true });
      }
      await actionSheet.present();
      const { role } = await actionSheet.onDidDismiss();
      console.log('onDidDismiss resolved with role', role);
    } finally {
      this.isActionSheetPresented = false;
      if (isIOS && !this.storyModalOpen) {
        await NativeLiquidGlass.setChromeSuppressed({ suppressed: false }).catch(() => undefined);
        await NativeLiquidGlass.restoreRegions().catch(() => undefined);
      }
    }
  }

  async presentModal() {
    if (!this.hasActiveProfile()) {
      return;
    }

    this.syncProfileReference();
    //let not_allowed = ['land', 'eventos', 'epoch',  'earth'];
     let not_allowed = [''];
    let modal = null;
    if(not_allowed.includes(this.formservice.publication_type)) {
      // abrir proximamente
      modal = await this.modalController.create({
canDismiss: true,
        component: ModulesLockComponent,
        cssClass: 'my-custom-class detailsInModal',
        componentProps: {

        }
      });
    }else if(this.formservice.publication_type==='live'){
      await this.router.navigate(['/chime-contact'], {
        queryParams: {
          'webview-live': 'true',
          username: 'Laniakea_supercumulo',
          isPublication: 'true',
          broadcast: 'true',
          profile_photo: 'https://laniakea-multimedia.s3.us-east-1.amazonaws.com/public/250202040118_2025-02-02T04-01-15-313Z.png.jpg',
        },
      });
      return;

    }  else if(this.formservice.publication_type==='dropship'){
      this.router.navigate(['/dropship-product-selection']);
    }else if(this.formservice.publication_type==='ShootingStars'){
      modal = await this.modalController.create({
canDismiss: true,
        component: ShootingStar6Component,
        cssClass: 'my-custom-class detailsInModal',
        componentProps: {
          ShootingStars: true,
        }
        
      });
    }else{
      await this.router.navigate(['/create-publication'], {
        queryParams: {
          publicationType: this.formservice.publication_type,
        },
      });
      return;
    }

    return await modal.present();
  }
  async openBrowser(url: string) {
		//await Browser.open({ url });
		const modal = await this.modalController.create({
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)
			component: InlineBowsingComponent,
			componentProps: {
				url: url,
			
			},
		  });
		  modal.onDidDismiss().then((data)=>{
			
		  });
		  return await modal.present();
		window.open(url, '_blank'); // Open the URL in a new tab or window
	  }
  async presentModalHistory() {
    if (this.storyModalOpen) return;
    // Set this before the first await: the action sheet's dismiss handler runs
    // while the modal is being created and must not restore native chrome.
    this.storyModalOpen = true;
    const isIOS = Capacitor.getPlatform() === 'ios';
    try {
      if (isIOS) {
        await NativeLiquidGlass.setChromeSuppressed({ suppressed: true });
      }
      const publication = new StatePublication();
      publication.publication_type = 'state';
      const modal = await this.modalController.create({
        canDismiss: true,
        component: HistoryViewComponent,
        cssClass: 'story-creation-modal',
        componentProps: { title: 'Nueva Historia', publication },
      });
      await modal.present();
      await modal.onDidDismiss();
    } finally {
      this.storyModalOpen = false;
      if (isIOS) {
        await NativeLiquidGlass.setChromeSuppressed({ suppressed: false }).catch(() => undefined);
        await NativeLiquidGlass.restoreRegions().catch(() => undefined);
      }
    }
  }

  private openKYCApplicationModal(app:any) {
    if (!this.hasActiveProfile()) {
      return;
    }

    this.syncProfileReference();
		this.walletService.KYC_validation().then((result_kyc) => {
		  if (result_kyc['permit']) {
			this.showAppModal(app);
		  } else if (this.pr.kyc === "Sin Validar") {
			this.showPagoVerificacionModal();
		  } else  {
			this.showPagoVerificacionModal();
		  }
		}).catch((error) => {
		  console.error(error);
		});
	  }
	  
	  private showAppModal(app) {
      let ecosystem = app;
      this.formservice.publication_type = ecosystem
      this.presentModal();
	  }
	  
	  private showSliderInformationModal() {
		this.inputAlertController.OkInfoMessage(
		  'Usuario no verificado',
		  'Esta característica solo está disponible para usuarios verificados, sigue los pasos en la sección de configuración de la cuenta y completa la verificación de la cuenta para acceder a esta funcionalidad',
		  'Ir a completar mi perfil'
		);
		this.modalController.create({
canDismiss: true,
		  component: SliderInformationComponent,
		  componentProps: {
			pr: this.pr,
		  },
		}).then((modal) => {
		  modal.present();
		}).catch((error) => {
		  console.error(error);
		});
	  }
	  
	  private showPagoVerificacionModal() {
		this.inputAlertController.OkInfoMessage(
		  'Usuario no verificado',
		  'Esta característica solo está disponible para usuarios verificados, sigue los pasos en la sección de configuración de la cuenta y completa la verificación de la cuenta para acceder a esta funcionalidad',
		  'Ir a completar mi perfil'
		);
		console.log("entro al else if ");
	  
		this.modalController.create({
		  component: PagoVerificacionComponent,
		  canDismiss: true, // (forced globally for swipe close on all modals)
		  componentProps: {
			pr: this.pr
		  }
		}).then((modal) => {
		  modal.present();
		});
	  }	  
    async openEntrelazamiento(){
      await this.router.navigate(['/create-publication'], {
        queryParams: {
          entrelazamiento: 'true',
          publicationType: this.formservice.publication_type,
        },
      });
    }
}
